module.exports = __webpack_public_path__ + "6c7b67b4981990d1af44eae8f24aefaa.png";